import { Injectable } from "@angular/core";
import { CoreHttpClient } from "@obg/ngx.core";
import { Observable } from "rxjs";

import { CustomerAssessmentsConfigService } from "./customer-assessments.config";
import { AssessmentsFilter, CustomerAssessments, CustomerAssessmentsModel } from "./customer-assessments.model";

/**
 * @deprecated [fabric-deprecated] - Use CustomerAssessmentService from app-account instead
 */
@Injectable({
	providedIn: "root",
})
export class CustomerAssessmentsService {
	constructor(
		private config: CustomerAssessmentsConfigService,
		private httpClient: CoreHttpClient
	) {}

	/**
	 * @deprecated [fabric-deprecated] - Use "document.obgEventBus.dispatch(AccountAppCommand.SubmitAnswers)" instead
	 */
	submitAnswers({ answers }: CustomerAssessmentsModel, assessmentId: string): Observable<object> {
		return this.httpClient.patch({
			url: `${this.config.getCustomerAssessmentEndpoint()}/${assessmentId}`,
			data: {
				answers,
			},
		});
	}

	/**
	 * @deprecated [fabric-deprecated] - Use "document.obgEventBus.retrieve(AccountAppValue.GetAssessment)" instead
	 */
	getAssessment(assessmentId: string): Observable<object> {
		return this.httpClient.get({
			url: `${this.config.getCustomerAssessmentEndpoint()}/${assessmentId}`,
		});
	}

	/**
	 * @deprecated [fabric-deprecated] - Use "document.obgEventBus.retrieve(AccountAppValue.getCustomerAssessments)" instead
	 */
	getCustomerAssessments(params: AssessmentsFilter): Observable<CustomerAssessments[]> {
		return this.httpClient.get<CustomerAssessments[]>({
			url: this.config.getCustomerAssessmentEndpoint(),
			searchParams: {
				status: params.status,
				fulfillmentMode: params.fulfillmentMode,
				assessmentType: params.assessmentType,
			},
		});
	}
}
